import ICustomForm from "../../ICustomForm";
import ICustomFormSettings from "../../ICustomFormSettings";
import m, {Vnode} from "mithril";
import {LabelItem} from "../../../model/items/labelItem";
import {RadioItem} from "../../../model/items/radio";
import RTMCard, {RTMCardOptions} from "../RTMCard";
import {SyntheticItem} from "../../../model/items/synthetic";
import RTM from "../RTM";
import {Answer} from "../RTMCard";
import {ImageItem} from "../../../model/items/imageItem";
import $ from "jquery";

export default class RTMDefault extends RTM implements ICustomForm
{
    private readonly question: string|null = null;
    private readonly negativeValue: string|null = null;
    private readonly positiveValue: string|null = null;
    private card!: RTMCard; // set oninit

    private readonly timerVariableName: string|null = null; // Synthetic variable, optional
    private readonly answerVariableName!: string; // set in constructor or fail in checkRequirements

    private readonly image: string|null;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        let image = null;
        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                // Question
                if (cell.column === 1 && !this.question && cellItem instanceof LabelItem) {
                    this.question = cell.cellItems[0].childrenTags[0]?.value!;
                }
                // Negative answer value
                if (this.negativeValue === null && cell.column === 0 && cellItem instanceof RadioItem) {
                    this.negativeValue = cellItem.getValue();
                    this.answerVariableName = cell.cellItems[0].variableName;
                }
                // Positive answer value
                if (this.positiveValue === null && cell.column === 2 && cellItem instanceof RadioItem) {
                    this.positiveValue = cellItem.getValue();
                }
                // Timer variable // TODO
                if (this.timerVariableName === null && cellItem instanceof SyntheticItem) {
                    this.timerVariableName = cellItem.variableName;
                }
                // Image
                if (cellItem instanceof ImageItem) {
                    image = this.settings.form.questionary.getFileUrl(cellItem.file);
                }

            }
        }

        this.image = image;
    }

    checkRequirements(): boolean {
        // If setup in constructor not succeeded, these values are null

        if (this.negativeValue === null) { // answerVariableName checked
            console.log('customForm-RTM-default: Unable to find negative value. Is radio in column 0?');
            return false;
        }
        if (this.positiveValue === null) {
            console.log('customForm-RTM-default: Unable to find positive value. Is radio in column 2?');
            return false;
        }

        if (!this.question) {
            console.log('customForm-RTM-default: Unable to find question. Is it label on row 0, column 1?');
            return false;
        }

        return true;
    }

    public view(): Vnode {
        return this.viewLayout([
            this.viewHintBar(),
            m(this.card),
        ]);
    }

    private onAnswerChange(answer: Answer|null) {
        this.chosenAnswer = answer;
    }

    private onFinish() {
        let value;
        switch (this.chosenAnswer) {
            case "positive": value = this.positiveValue; break;
            case "negative": value = this.negativeValue; break;
            default: value = undefined; // unset
        }
        const form = this.settings.form;
        this.setVariable(this.answerVariableName, value);

        if (value && form.id === form.questionary.currentForm?.id && form.validate()) {
            this.settings.nextForm(); // in case there is no submit form
        }
        m.redraw();
    }

    oninit() {
        const options: RTMCardOptions = {cardClass: 'fade-in-zoom'};
        if (this.image !== null) {
            options['image'] = this.image;
        }

        this.card = new RTMCard(
            this.question!,
            this.onAnswerChange.bind(this),
            this.onFinish.bind(this),
            this.settings.form.questionary,
            options
        );
    }

    public onremove(): void {
        $(document).off('keydown');
        $(document).off('keyup');
    }
}


/* --------------------- :-)

   Joke for better day


 Don't threat women as object!

 Meanwhile Me:
 let woman = new Woman();

 ------------------------ */